/*require('./../../style/input.less');*/
var $ = require('jQuery');
var template = require('../../template/input.html');
var Component = require('./../Component');
var PreviewImage = require('./plugin/PreviewImage');
//var stat = require('./../../global/stat');
//var StatPoint = require('./../../constant/StatPoint');
var XssFilter = require('../../../lib/XssFilter');
var AppPosition = require('./../../constant/AppPosition');
var gdic = require('./../../global/globalDic');


var Input = function (options) {
  (function (self) {
    var defaults = {
      template: template,
      plugins: [],
      editor: null
    };
    $.extend(defaults, options);
    Component.call(self, defaults);

    $(defaults.plugins).each(function (index, plugin) {
      self._element.find('.im-input-plugins').append(plugin.getElement());
      plugin.setInput(self);
    });

    self._element.find('.im-input-text').append(defaults.editor.getElement());
    defaults.editor.setInput(self);

  })(this);

  (function (self) {
    self._element.find('.im-send').on("click", function () {
      //埋点统计（发送按钮点击）
      var value = self._options.editor.get().msg;
      if (!isShowNotice.call(self, value)) {
        //stat.report(StatPoint.msg_send);
        var position = gdic.get('position');
        //发送消息的埋点统计：center_session_click为事件ID=11,normal_session_click事件ID=10
        var id = position == AppPosition.CENTER ? 11 : 10;
        if(window.WMDA_REPORT){
          window.WMDA_REPORT('custom',{event_id:id})
        }      
      }
       self.send();
    });
    //footer点击获取文本框焦点
    self._element.find('.im-input-footer').on("click", function (e) {
      if (e.target.className != 'im-send') {
        self._options.editor.focus();
      }
    });
  })(this);
};
var isShowNotice = function (value) {
  var self = this;
  //发送内容为空
  if (value.length === 0) {
    var txt = '发送内容不能为空！';
    self.showNotice(txt);
    return true;
  }
  //发送内容全部为换行
  var value1 = value.replace(/&nbsp;/g, "").replace(/<br>/g, "").replace(/\s/g, "");
  if (value1.length == 0) {
    var txt = '不支持仅包含空格或换行符的消息！';
    self.showNotice(txt);
    self._options.editor.clear();
    return true;
  } else {
    return false;
  }

};
Input.prototype = Object.create(Component.prototype);
Input.prototype.showNotice = function (txt) {
  this._element.find('.im-input-notice').show().text(txt);
};
Input.prototype.hideNotice = function () {
  this._element.find('.im-input-notice').hide().text('');
};
Input.prototype.showSend = function () {
  this._element.find('.im-send').show();
  this._element.find('.im-send-notice').css('right','112px')
};
Input.prototype.hideSend = function () {
  this._element.find('.im-send').hide()
  this._element.find('.im-send-notice').css('right','24px')
};
Input.prototype.setMaxInputLength = function (len) {
  this.maxInputLength = len;
};
Input.prototype.getMaxInputLength = function () {
  return this.maxInputLength;
};
Input.prototype.send = function (value) {
  var self = this;
  if (value) {
    self.triggerEvent('inputCompleted', value);
    return;
  }
  var value = self._options.editor.get().msg;
  //emotion转化为文本
  value = self._options.editor.emotionToText(value);
  //&amp;处理
  value = value.replace(/&amp;/gi, '&');
  //文本多个空格替换
  value = value.replace(/&nbsp;/gi, ' ');
  //换行处理
  value = value.replace(/<br>/gi, '\n');
  // xssFilter,将&lt;替换成'<' ,将&gt;替换成'>'
  value = XssFilter.resetFilter(value);
  var flag = isShowNotice.call(self, value);
  if (flag == true) {
    return;
  }
  var inputValue = {
    msg: value,
    type: 'text'
  };
  var inputLength = inputValue.msg.length;
  var maxLength = self.getMaxInputLength();
  if (inputLength > maxLength) {
    var counts = Math.ceil(inputLength / maxLength);
    var content;
    for (var i = 0; i < counts; i++) {
      if (i != counts - 1) {
        content = inputValue.msg.slice((i) * maxLength, (i + 1) * maxLength);
      } else {
        content = inputValue.msg.slice((i) * maxLength, inputLength);
      }
      var msgobj = {
        msg: content,
        type: 'text'
      };
      self.triggerEvent('inputCompleted', msgobj);
    }
  } else {
    self.triggerEvent('inputCompleted', inputValue);
  }
  self._options.editor.clear();
  self._options.editor.focus();
  self.hideSend();
  self.hideNotice();
};
Input.prototype.imgSend = function (file) {
  var self = this;
  self.hideNotice();
  if (file.name) {
    var arr = file.name.split('.');
    var ext = arr[arr.length - 1];
    ext = ext.toLowerCase();
    this.value = '';
    var exts = ['jpg', 'jpeg', 'png', 'gif'];
    if (exts.indexOf(ext) === -1) {
      self.showNotice('请选择jpg、jpeg、png或gif格式的图片');
      return;
    }
  }
  var reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    var data = this.result;
    //加载图片获取图片真实宽度和高度
    var image = new Image();
    image.onload = function () {
      console.log('draged');
      self.send({
        type: 'image',
        url: data,
        image_width: image.width,
        image_height: image.height
      });
    };
    image.src = data;
  };
};
Input.prototype.fileSend = function (file) {
  var self = this;
  var maxFileSize = 30 * 1024 * 1024;
  var file_type;
  self.hideNotice();
  if (file.name) {
    var arr = file.name.split('.');
    var ext = arr[arr.length - 1];
    ext = ext.toLowerCase();
    this.value = '';
    var file_exts = ['txt', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'ppt', 'pptx', 'pages','numbers','key'];
    var video_exts = ['mp4'];
    if (file_exts.indexOf(ext) !== -1) {
      file_type = 'file';
    } else if (video_exts.indexOf(ext) !== -1) {
      file_type = 'video';
    }
    var exts = file_exts.concat(video_exts);
    if (exts.indexOf(ext) === -1) {
      self.showNotice('文件格式暂不支持发送!');
      return;
    }
  }
  if (file.size && file.size > maxFileSize) {
    self.showNotice('文件不能超出30M!');
    return;
  }
  if (file.size === 0) {
    self.showNotice('不能发送大小为0的文件');
    return;
  }
  self.send({
    type: file_type,
    url: file
  });
};

Input.prototype.previewImage = function (file) {
  var self = this;
  var previewImage = new PreviewImage({
    files: file
  });
  previewImage.setInput(self);
  self._element.find('.im-input-plugins').append(previewImage.getElement());
};
Input.prototype.askContactinfo = function (params) {
  var self = this;
  self.triggerEvent('askContactinfo', params);
};


module.exports = Input;